import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import { FetchContext } from 'context/FetchContext';

function useReorderPodcast() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  function reorderPodcast(data) {
    return privateFetch.put('/v1/admin/podcast/podcasts/reorder', data);
  }

  return useMutation(reorderPodcast, {
    onSuccess() {},
    onError(error) {
      console.error('Failed to reorder podcasts:', error);
    },
  });
}

export default useReorderPodcast;
